import styled from 'styled-components/macro';

const AppWrapper = styled.div`
  display: flex;
  min-height: 100vh;
  flex-direction: column;
`;

export default AppWrapper;
